// extracted by mini-css-extract-plugin
export default {"task":"ProfileUser_task__x6wDB","progress":"ProfileUser_progress__Gq2q9"};